import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { api } from '@/lib/api';
import { LogOut, ShieldAlert } from 'lucide-react';

/**
 * Impersonation banner. Shown at the top of any console layout when the
 * `h_admin_backup` token is present in localStorage, indicating that an
 * admin has assumed another user's session. Clicking "Return" restores the
 * admin session and navigates back to /admin/members.
 */
export default function ImpersonationBanner() {
  const { user, refresh } = useAuth();
  const navigate = useNavigate();
  const [backup, setBackup] = useState(localStorage.getItem('h_admin_backup'));

  useEffect(() => {
    const onStorage = () => setBackup(localStorage.getItem('h_admin_backup'));
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, []);

  if (!backup) return null;

  const restore = async () => {
    const adminToken = localStorage.getItem('h_admin_backup');
    if (adminToken) {
      localStorage.setItem('h_token', adminToken);
      localStorage.removeItem('h_admin_backup');
      setBackup(null);
      await refresh();
      navigate('/admin/members');
    }
  };

  return (
    <div className="w-full text-white text-sm sticky top-0 z-50" style={{ background: '#4B1838' }} data-testid="impersonation-banner">
      <div className="max-w-[1600px] mx-auto px-5 py-2.5 flex flex-wrap items-center justify-between gap-2">
        <div className="flex items-center gap-2">
          <ShieldAlert size={16} />
          <span>Admin preview mode. Viewing as <strong>{user?.name || user?.email}</strong> ({user?.role})</span>
        </div>
        <button onClick={restore} className="inline-flex items-center gap-2 px-3 py-1 rounded-full" style={{ background: 'rgba(246,240,228,0.15)' }} data-testid="impersonation-exit">
          <LogOut size={14} /> Return to Admin
        </button>
      </div>
    </div>
  );
}
